export default "__VITE_ASSET__CissFPJ9__"